import letterDataAa from './phonics/phonics_data_aa';
import PhonicsAtoZ from './PhonicsAtoZ';

/**
 * Letter Aa 包装组件
 * 复用 PhonicsAtoZ 通用组件
 */
export default function PhonicsAa() {
  return <PhonicsAtoZ letterData={letterDataAa} />;
}
